export const getImageUrl = (product) => {
  
  return (
    product?.imageUrl ??
    product?.primaryAttachment?.imageUrl ??
    product?.pictures?.[0]?.imageUrl
  );
}

